import type { ReactNode } from 'react'

import { Typography as MuiTypography, type TypographyProps as MuiTypographyProps } from '@mui/material'

type CustomSize = 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'
type CustomWeight = 'light' | 'regular' | 'medium' | 'semibold' | 'bold'

const fontSizeMap: Record<CustomSize, number> = {
	xxs: 12,
	xs: 20,
	sm: 24,
	md: 28,
	lg: 32,
	xl: 40,
	xxl: 64
}

const fontWeightMap: Record<CustomWeight, number> = {
	light: 300,
	regular: 400,
	medium: 500,
	semibold: 600,
	bold: 700
}

export type TypographyProps = {
	fontSize?: CustomSize
	fontWeight?: CustomWeight
	children: ReactNode
	color?: string
} & Omit<MuiTypographyProps, 'fontSize' | 'fontWeight'>

export const Typography = ({ fontSize, fontWeight, children, color, ...props }: TypographyProps) => {
	return (
		<MuiTypography
			{...(fontSize && { fontSize: fontSizeMap[fontSize] })}
			{...(fontWeight && { fontWeight: fontWeightMap[fontWeight] })}
			color={color || 'textPrimary'}
			{...props}
		>
			{children}
		</MuiTypography>
	)
}
